import React, { useContext, useEffect, useState } from 'react';
import { Routes, Route, Link, Navigate } from 'react-router-dom';
import NavPanel from '../../../Components/NavPanel/NavPanel';
import AboutBeer from '../AboutBeer/AboutBeer';
import AboutLambic from '../AboutLambic/AboutLambic';
import AboutPhilosophy from '../AboutPhilosophy/AboutPhilosophy';
import AboutContacts from '../AboutContacts/AboutContacts';
import AboutVacancies from '../AboutVacancies/AboutVacancies';
import classes from './AboutGeneral.module.scss';
import { AboutContext } from '../../../context/aboutContext';
import { GeneralContext } from '../../../context/generalContext';
import AboutInfo from '../AboutInfo/AboutInfo';
import { aboutInfoLinkAPI } from '../../../services/GeneralService';
import { checkIsTashkent } from '../../../functions/checkCity/checkCity';
import NotFound from '../../NotFound/NotFound';

export default function About() {
  const { setActiveSection, activeSection } = useContext(AboutContext);
  const { data: infoLinks } = aboutInfoLinkAPI.useFetchAllAboutInfoLinkQuery();
  const { activeLanguage, path, setPath } = useContext(GeneralContext);

  const sections = [
    {
      id: 1,
      name: 'Brasserie Lambic',
      path: '/info',
      name_en: 'Brasserie Lambic',
      component: <AboutLambic />,
      showForTashkent: true,
    },
    {
      id: 2,
      name: 'Философия',
      path: '/philosophy',
      name_en: 'Philosophy',
      component: <AboutPhilosophy />,
      showForTashkent: false,
    },
    {
      id: 3,
      name: 'Знакомьтесь, пиво Ламбик',
      path: '/lambic',
      name_en: 'Meet Lambic beer',
      component: <AboutBeer />,
      showForTashkent: false,
    },
    {
      id: 4,
      name: 'Контакты',
      path: '/contacts',
      name_en: 'Contacts',
      component: <AboutContacts />,
      showForTashkent: true,
    },
    {
      id: 5,
      name: 'Вакансии',
      path: '/vacancy',
      name_en: 'Vacancy',
      component: <AboutVacancies />,
      showForTashkent: true,
    },
  ];
  const isTashkent = checkIsTashkent();
  const sectionsToRender = isTashkent ? [...sections.filter(section => section.showForTashkent)] : sections;

  // устанавливаем path (используется для переключения языка (в header))
  useEffect(() => {
    setPath(window.location.pathname);
  });

  if (path === '/about' || path === '/about/') return <Navigate to='/about/info' />;
  if (path === '/en/about' || path === '/en/about/') return <Navigate to='/en/about/info' />;

  return (
    <div className='wrapper'>
      <NavPanel
        name={activeLanguage === 1 ? 'О нас' : 'About us'}
        link={activeLanguage === 1 ? '/about/info' : '/en/about/info'}
      />
      {path.replace('/en', '').split('/').length < 4 && (
        <>
          <h1 className={classes.header}>{activeLanguage === 1 ? 'О нас' : 'About us'}</h1>
          <div id='AboutSections' className={classes.AboutSections}>
            {sectionsToRender.map(section => (
              <Link
                to={activeLanguage === 1 ? `/about${section.path}` : `/en/about${section.path}`}
                className={`${classes.AboutSectionItem} ${
                  activeSection === section.id ? `${classes.activeSecitonItem}` : ''
                }`}
                onClick={() => setActiveSection(section.id)}
                key={section.id}
              >
                {activeLanguage === 1 ? section.name : section.name_en || section.name}
              </Link>
            ))}
          </div>
        </>
      )}

      <Routes>
        {sectionsToRender.map(section => (
          <Route path={section.path} element={section.component} key={section.id} />
        ))}
        {sectionsToRender.map(section => (
          <Route path={`/en${section.path}`} element={section.component} key={section.id} />
        ))}
        <Route path='*' element={<NotFound />} />

        {!isTashkent &&
          infoLinks &&
          infoLinks.map(infoLink => (
            <Route
              key={infoLink.id}
              path={infoLink.link.slice(infoLink.link.indexOf('/', 1))}
              element={<AboutInfo />}
            />
          ))}
      </Routes>
    </div>
  );
}
